import { CustomShape } from './custom-shape';

export class RoundedSquare extends CustomShape {

  // see GfxAlgorithms::createRoundedSquare
  drawPath (context) {
    const size = 2 * this.radius_;
    const radius = size / 8;

    context.beginPath();
    context.moveTo(radius, 0);
    context.lineTo(size - radius, 0);
    context.lineTo(size, radius); // corners are not really round
    context.lineTo(size, size - radius);
    context.lineTo(size - radius, size);
    context.lineTo(radius, size);
    context.lineTo(0, size - radius);
    context.lineTo(0, radius);
    context.closePath();
  }

}
